// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"7ea35c22","29":"7ea35c22","251":"7ea35c22","849":"7ea35c22","931":"7ea35c22","994":"f40fe96a"}[chunkId] + ".chunk.css";
};